module.exports = __webpack_public_path__ + "img/11_Kombipaket-1.1dbed229.jpg";